export default __webpack_public_path__ + "components/page-header/static/icon-caret-down-e7404984ce71016e6e6510195a5edc41.svg";